import Search from "discourse/plugins/chat/discourse/components/chat/routes/search";

export default <template><Search @query={{@controller.q}} /></template>
